import { render, staticRenderFns } from "./template-add-edit-dialog.vue?vue&type=template&id=1bba9a27&scoped=true"
import script from "./template-add-edit-dialog.vue?vue&type=script&lang=js"
export * from "./template-add-edit-dialog.vue?vue&type=script&lang=js"
import style0 from "./template-add-edit-dialog.vue?vue&type=style&index=0&id=1bba9a27&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bba9a27",
  null
  
)

export default component.exports